/* unplugin-vue-components disabled */import { render } from "./SettingsItem.vue?vue&type=template&id=0f1b0d26&ts=true"
import script from "./SettingsItem.vue?vue&type=script&lang=ts"
export * from "./SettingsItem.vue?vue&type=script&lang=ts"

import "./SettingsItem.vue?vue&type=style&index=0&id=0f1b0d26&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__